<template>
  <div class="box1-page">
    <div class="box1-top">
      <h2>课程焕新升级 V4.0</h2>
      <h1>IP短视频带货训练营</h1>
      <p>精准解锁 <b>推荐、<i></i></b><b>搜索、<i></i></b><b>付费<i></i></b> 三大流量密码</p>
      <p>实现IP视频带货，成就你的超级副业！</p>
    </div>
  <div class="box1-bottom">
    <div class="bottom-item">
      <h3>7-10<em>年</em></h3>
      <p>专业运营讲师团</p>
    </div>
    <div class="bottom-item">
      <h3>180<em>天</em></h3>
      <p>高标准/精细化监督陪跑</p>
    </div>
    <div class="bottom-item">
      <h3>90<em>+</em></h3>
      <p>核心关键知识点</p>
    </div>
    <div class="bottom-item">
      <h3>3000<em>+</em></h3>
      <p>优秀毕业学员</p>
    </div>
    <div class="bottom-item">
      <a>先试学再报名</a>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        
      }
    }
  }
</script>

<style lang="scss" scoped>
  .box1-page{
    width: 100%;
  height: 600px;
  background:  url("../../../assets/coursePage/newMedia2/box1/bg.png")
    no-repeat;
  background-size: cover;
  background-position: center;
  height: 1125px;
  box-sizing: border-box;
  .box1-top{
    margin-bottom: 210px;
    padding: 70px 30px 0;
    h2{
      font-family: PingFang-SC-Bold;
	font-size: 30px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 51px;
  text-align: center;
	letter-spacing: 0px;
	color: #ffffff;
  width: 290px;
	height: 51px;
	background-color: #fd5a57;
	border-radius: 25px 25px 25px 0px;
    }
    h1{
      font-family: PingFang-SC-Heavy;
	font-size: 60px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 72px;
	letter-spacing: 0px;
	color: #1a0a0e;
  margin: 48px 0 ;
    }
    p{
      font-family: PingFang-SC-Medium;
	font-size: 26px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #1a0a0e;
  margin-bottom: 18px;
      b{
        position: relative;
        display: inline-block;
        font-weight: bold;
        i{
position: absolute;
bottom: -1px;
left: 0;
display: inline-block;
          width: 50px;
	height: 4px;
	background-color: #fd5a57;
        }
      }
    }
    p:last-child{
      margin-bottom:0
    }
  }
  .box1-bottom{
    background-color:rgba(255,255,255,0.3);
    border-top: 1px solid #fff;
    padding: 30px;
    display: flex;
    margin: 0 -30px -30px 0;
    flex-wrap: wrap;
    .bottom-item{
      width: 326px;
	height: 135px;
	background-color: #ffffff;
	border-radius: 8px;
	border: solid 1px #ffffff;
  margin-right: 30px;
  margin-bottom: 30px;
  text-align: center;
  >a{
    font-family: PingFang-SC-Bold;
	font-size: 40px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 135px;
  text-align: center;
	letter-spacing: 0px;
	color: #4d1f28; 
  }
    }
    :last-child{width:100%}
    h3{
      font-family: DINCondensed-Bold;
	font-size: 54px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 54px;
	letter-spacing: 0px;
	color: #4d1f28;
  position: relative;
  padding-bottom: 17px;
  padding-top: 24px;
  text-align: center;
      em{
        font-family: PingFangSC-Regular;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 20px;
	letter-spacing: 0px;
	color: #4d1f28;
  position: absolute;
  right:-58px;
  font-style: normal;
  top: 30px;

      }
     
     
    }
    p{
      text-align: center;
      font-family: PingFangSC-Regular;
	font-size: 24px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 20px;
	letter-spacing: 0px;
	color: #4d4d4d;
    }
    .bottom-item:nth-child(1){
      em{
        position: absolute;
        right: -68px;
      }
    }
    .bottom-item:nth-child(3){
      em{
        position: absolute;
        right: -45px;
      }
    }
    .bottom-item:nth-child(4){
      em{
        position: absolute;
        right: -70px;
      }
    }
  }
  }
</style>